import { createWebHistory, createRouter } from 'vue-router';
import { authGuard } from './auth-guard';

const routes = [
	{path: '/:catchAll(.*)', redirect:{name:'Login'}},
	{
		path:'/login',
		name:'Login',
		component:()=>import('@/components/authentication/Layout.vue')
	},{
		path:'/admin',
		name:'PageLayout',
		beforeEnter:authGuard,
		component:()=>import('@/components/authentication/PageLayout.vue'),
		children:[
			{
				path:'/dashboard',
				name:'Dashboard',
				component:()=>import('@/components/Pages/dashboard.vue')
			},{
				path:'/schedule',
				component:()=>import('@/components/Pages/schedule.vue')
			},{
				path:'/channel',
				name:'Channel',
				component:()=>import('@/components/Pages/channel.vue')
			},{
				path:'/schedule',
				component:()=>import('@/components/Pages/schedule.vue')
			},{
				path:'/package',
				name:'Package',
				component:()=>import('@/components/Pages/package.vue')
			},{
				path:'/subscriber',
				name:'Subscriber',
				component:()=>import('@/components/Pages/subscriber.vue')
			},{
				path:'/account/user',
				name:'User',
				component:()=>import('@/components/account/user.vue')
			},{
				path: '/account/inventory',
				name: 'Inventory',
				component: () => import('@/components/account/inventory.vue')
			},{
				path:'/account/organization',
				name:'Organization',
				component:()=>import('@/components/account/organization.vue')
			},{
				path:'/account/profile',
				name:'Profile',
				component:()=>import('@/components/account/updateProfile.vue')
			},{
				path:'/account/backup',
				name:'Backup',
				component:()=>import('@/components/account/backup.vue')
			},{
				path:'/account/databse-config',
				name:'DatabaseConfig',
				component:()=>import('@/components/account/databaseConfig.vue')
			},{
				path:'/account/aboutus',
				name:'Aboutus',
				component:()=>import('@/components/account/aboutus.vue')
			},{
				path:'/account/token',
				name:'Token',
				component:()=>import('@/components/account/token.vue')
			},{
				path:'/account/paymentgateway',
				name:'Payment Gateway',
				component:()=>import('@/components/account/paymentgateway.vue')
			},{
				path:'/account/wallet',
				name:'Wallet',
				component:()=>import('@/components/account/wallet.vue')
			},
			{
				path:'/account/smsgateway',
				name:'SMS Gateway',
				component:()=>import('@/components/account/smsgateway.vue')
			},
			{
				path:'/account/walletBalance',
				name:'Wallet Balance',
				component:()=>import('@/components/account/walletBalance.vue')
			},
			{
				path:'/account/billPayment&reconcilationfeature',
				name:'Bill Payment & Reconcilation Feature',
				component:()=>import('@/components/account/billPayment&reconcilationfeature.vue')
			},
			{
				path:'/account/privacy',
				name:'Privacy',
				component:()=>import('@/components/account/fingerprint.vue')
			},{
				path:'/login',
				name:'Logout',
				component:()=>import('@/components/authentication/Logout.vue')
			},{
				path:'/account/invoice_setting',
				name:'Invoice',
				component:()=>import('@/components/account/invoiceSetting.vue')
			},{
				path:'/account/sms_settings',
				name:'SMSSettings',
				component:()=>import('@/components/account/smsSettings.vue')
			},{
				path: '/account/ticket',
				name: 'Ticket',
				component: () => import('@/components/account/ticket.vue')
			},{
				path: '/account/bulkoperation',
				name: 'BulkOperation',
				component: () => import('@/components/account/bulkoperation.vue')
			},{
				path:'/account/serversetting',
				name:'Server',
				component:()=>import('@/components/account/serversetting.vue')
			},{
				path:'/account/renewalsetting',
				name:'Renewal & Reversal Settings',
				component:()=>import('@/components/account/renewalSettings.vue')
			},{
				path:'/account/endpoint',
				name:'Endpoint',
				component:()=>import('@/components/account/endpoint.vue')
			}, {
				path: '/account/role',
				name: 'Role',
				component: () => import('@/components/account/role.vue')
			}, {
				path: '/account/headend',
				name: 'Headends',
				component: () => import('@/components/account/headends.vue')
			}, {
				path: '/account/comparereport',
				name: 'compareReports',
				component: () => import('@/components/account/compareReports.vue')
			},{
				path:'/report/ChannelWiseReport',
				name:'ChannelWiseReport',
				component:()=>import('../components/report/ChannelWiseReport.vue')
			},{
				path:'/report/SubscriptionChangeLogs',
				name:'SubscriptionChangeLogs',
				component:()=>import('../components/report/SubscriptionChangeLogs.vue')
			},
			{
				path:'/report/DrmCommandReport',
				name:'DrmCommandReport',
				component:()=>import('../components/report/DrmCommandReport.vue')
			},
			{
				path:'/report/ExtractLogsReport',
				name:'ExtractLogsReport',
				component:()=>import('../components/report/ExtractLogsReport.vue')
			},
			{
				path:'/report/ApiLogsReport',
				name:'ApiLogsReport',
				component:()=>import('../components/report/ApiLogsReport.vue')
			},
			{
				path:'/report/DpoPackageReport',
				name:'DpoPackageReport',
				component:()=>import('../components/report/DpoPackageReport.vue')
			},
			{
				path:'/report/FingerPrintReport',
				name:'FingerPrintReport',
				component:()=>import('../components/report/FingerPrintReport.vue')
			},
			{
				path:'/report/InventoryReport',
				name:'InventoryReport',
				component:()=>import('../components/report/InventoryReport.vue')
			},
			{
				path:'/report/InventoryLogsReport',
				name:'InventoryLogsReport',
				component:()=>import('../components/report/InventoryLogsReport.vue')
			},
			{
				path:'/report/LocationwiseSTBReport',
				name:'LocationwiseSTBReport',
				component:()=>import('../components/report/LocationwiseSTBReport.vue')
			},
			{
				path:'/report/MessagingReport',
				name:'MessagingReport',
				component:()=>import('../components/report/MessagingReport.vue')
			},
			{
				path:'/report/MonthlySubscriptionAlacarteReport',
				name:'MonthlySubscriptionAlacarteReport',
				component:()=>import('../components/report/MonthlySubscriptionAlacarteReport.vue')
			},
			{
				path:'/report/MonthlySubscriptionPackageReport',
				name:'MonthlySubscriptionPackageReport',
				component:()=>import('../components/report/MonthlySubscriptionPackageReport.vue')
			},
			{
				path:'/report/Package&ChannelWiseSubscriberReport',
				name:'Package&ChannelWiseSubscriberReport',
				component:()=>import('../components/report/Package&ChannelWiseSubscriberReport.vue')
			},
			{
				path:'/report/Package&LocationWiseSubscriberReport',
				name:'Package&LocationWiseSubscriberReport',
				component:()=>import('../components/report/Package&LocationWiseSubscriberReport.vue')
			},
			{
				path:'/report/PackageChannelMappingReport',
				name:'PackageChannelMappingReport',
				component:()=>import('../components/report/PackageChannelMappingReport.vue')
			},
			{
				path:'/report/STBBlackListReport',
				name:'STBBlackListReport',
				component:()=>import('../components/report/STBBlackListReport.vue')
			},
			{
				path:'/report/STBWiseSubscriberReport',
				name:'STBWiseSubscriberReport',
				component:()=>import('../components/report/STBWiseSubscriberReport.vue')
			},
			{
				path:'/report/SubscriberSummaryReport',
				name:'SubscriberSummaryReport',
				component:()=>import('../components/report/SubscriberSummaryReport.vue')
			},
			{
				path:'/report/TemporarySuspendedReport',
				name:'TemporarySuspendedReport',
				component:()=>import('../components/report/TemporarySuspendedReport.vue')
			},
			// {
			// 	path:'/report/MonthEndActiveSTBReport',
			// 	name:'MonthEndActiveSTBReport',
			// 	component:()=>import('../components/report/MonthEndActiveSTBReport.vue')
			// },
			{
				path:'/report/AlacartePackageReport',
				name:'AlacartePackageReport',
				component:()=>import('../components/report/AlacartePackageReport.vue')
			},
			{
				path:'/report/ChannelCompositionAlacarteReport',
				name:'ChannelCompositionAlacarteReport',
				component:()=>import('../components/report/ChannelCompositionAlacarteReport.vue')
			},
			{
				path:'/report/SubscriptionChecklistLogs',
				name:'SubscriptionChecklistLogs',
				component:()=>import('../components/report/SubscriptionChecklistLogs.vue')
			},			
			{
				path: '/account/recocilation',
				name: 'reconcilation',
				component: () => import('@/components/account/reconcilation.vue')
			},
			{
				path:'/account/tokenizations',
				name: 'tokenizations',
				component: () => import('@/components/account/tokenizations.vue')
			},
			{
				path: '/report/UserLoginReport',
				name: 'UserLoginReport',
				component: () => import('../components/report/userLoginReport.vue')
			},
			{
				path: '/report/DbConfigLogs',
				name: 'DbConfigLogs',
				component: () => import('../components/report/dbConfigLogs.vue')
			},
			{
				path: '/account/readDb',
				name: 'Read DB',
				component: () => import('@/components/account/readDb.vue')
			},
			{
				path:'/report/PackageModificationLogs',
				name:'PackageModificationLogs',
				component:()=>import('../components/report/PackageModificationLogs.vue')
			},
			{
				path: '/skieSubscription',
				name: 'SkieSubscription',
				component: () => import('@/components/account/skieSubscription.vue')
			},
			{
				path: '/account/systemConfiguration',
				name: 'SystemConfiguration',
				component: () => import('@/components/account/systemConfiguration.vue')
			},
			{
				path:'/report/SubscriberFeesAndReversalReport',
				name:'SubscriberFeesAndReversalReport',
				component:()=>import('../components/report/SubscriberFeesAndReversalReport.vue')
			},
			{
				path: '/report/SubscriptiondetailsofTVchannels',
				name: 'SubscriptiondetailsofTVchannels',
				component: () => import('../components/report/SubscriptiondetailsofTVchannels.vue')
			},
			{
				path: '/report/StatewiseActiveSubscribers',
				name: 'StatewiseActiveSubscribers',
				component: () => import('../components/report/StatewiseActiveSubscribers.vue')
			},
			{
				path: '/report/Quarterly',
				name: 'Quarterly',
				component: () => import('../components/report/Quarterly.vue')
			},
			{
				path: '/account/msosettings',
				name: 'MSOSettings',
				component: () => import('@/components/account/msoSettings.vue')
			},
			{
				path: "/orgPackages",
				name: "Org Packages",
				component: () => import("@/components/account/orgPackages.vue")
			},
			{
				path: "/subscriptionrequest",
				name: "Subscription Request",
				component: () => import("@/components/account/subscriptionrequest.vue")
			},
			{
				path: '/report/zeereports',
				name: 'zeereports',
				component: () => import('../components/report/zeereports.vue')
			},
			{
				path: "/reportextraction",
				name: "Report Extraction",
				component: () => import("@/components/account/reportextraction.vue")
			},
			{
				path:'/report/orglogsreport',
				name:'OrgLogsReport',
				component:()=>import('../components/report/OrgLogsReport.vue')
			},
			{
				path:'/account/monitor',
				name:'Monitoring',
				component:()=>import('../components/account/monitor.vue')
			},
			{
				path: '/account/language',
				name: 'Language',
				component: () => import('../components/account/language.vue')
			},
			{
				path: '/account/presubscription',
				name: 'PreSubscription',
				component: () => import('../components/account/preSubscription.vue')
			},
			{
				path: '/account/promotion',
				name: 'Promotion',
				component: () => import('../components/account/promotion.vue')
			},
			{
				path: '/account/ottapps',
				name: 'OTTApps',
				component: () => import('../components/account/ottApps.vue')
			},
			{
				path: '/report/DpoMonthlySubscriptionAlacarteReport',
				name: 'DpoMonthlySubscriptionAlacarteReport',
				component: () => import('../components/report/DpoMonthlySubscriptionAlacarteReport.vue')
			},
		]
	}
];

const router = createRouter({
	history: createWebHistory(),
	hash:false,
	routes,
});

export default router;
